import React from "react";
import Container from "./ui/Container";
import { ExternalLink } from "lucide-react";

const OurWork = () => {
  const projects = [
    {
      title: "GC Pickles",
      description: "E-commerce platform for artisanal pickles and fermented goods",
      image: "/images/gcpickles.png",
      link: "https://gcpickles.com",
      tags: ["E-commerce", "Web Development", "Custom Design"]
    },
    {
      title: "Sys Cycles",
      description: "Modern cycling equipment and accessories marketplace",
      image: "/images/syscycles.png",
      link: "https://syscycles.com",
      tags: ["E-commerce", "Inventory Management", "Payment Integration"]
    },
    {
      title: "Horse BnB",
      description: "Marketplace platform connecting horse owners with boarding facilities",
      image: "/images/horse.png",
      link: "https://v0-horse-bnb-ypqukqiqpwe.vercel.app/",
      tags: ["Marketplace", "Booking System", "Location Services"]
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden" id="work">
      <Container>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-3 py-1 rounded-full bg-tech-cyan/10 text-tech-cyan font-medium text-sm mb-4 animate-fade-in opacity-0" style={{animationDelay: "0.1s", animationFillMode: "forwards"}}>
            Our Work
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-tech-blue mb-6 animate-fade-in opacity-0" style={{animationDelay: "0.2s", animationFillMode: "forwards"}}>
            Success Stories That Drive Results
          </h2>
          
          <p className="text-lg text-gray-700 animate-fade-in opacity-0" style={{animationDelay: "0.3s", animationFillMode: "forwards"}}>
            Explore how we've helped businesses transform their digital presence and achieve remarkable growth.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 animate-fade-in opacity-0"
              style={{animationDelay: `${0.4 + index * 0.1}s`, animationFillMode: "forwards"}}
            >
              <div className="aspect-video relative overflow-hidden bg-gray-100">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <a 
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer" 
                    className="absolute bottom-4 right-4 bg-white/90 text-tech-blue p-2 rounded-full hover:bg-white transition-colors duration-300"
                  >
                    <ExternalLink size={20} />
                  </a>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-tech-blue mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, tagIndex) => (
                    <span 
                      key={tagIndex}
                      className="text-sm bg-tech-blue/5 text-tech-blue px-3 py-1 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>

      {/* Decorative elements */}
      <div className="absolute -z-10 top-1/4 right-0 w-64 h-64 bg-tech-cyan opacity-5 rounded-full blur-3xl"></div>
      <div className="absolute -z-10 bottom-1/4 left-0 w-64 h-64 bg-tech-orange opacity-5 rounded-full blur-3xl"></div>
    </section>
  );
};

export default OurWork; 